import * as MerchantCertificateTemplateApi from '@/api/merchant-certificate-template'

/**
 * 电子奖状 - 证书模板
 */

const state = {}

const mutations = {}

const actions = {
  async query ({ commit }, params) {
    return MerchantCertificateTemplateApi.query(params)
  },
  async create ({ commit }, data) {
    return MerchantCertificateTemplateApi.create(data)
  },
  async findById ({ commit }, id) {
    return MerchantCertificateTemplateApi.findById(id)
  },
  async updateById ({ commit }, data) {
    const body = Object.assign({}, data)
    const id = body.id
    delete body.id
    return MerchantCertificateTemplateApi.updateById(id, body)
  },
  async deleteById ({ commit }, id) {
    return MerchantCertificateTemplateApi.deleteById(id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-certificate-template.js